export default __webpack_public_path__ + "static/media/stakeholder.c1fccb80.png";